<template>
  <div class="w-full bg-slate-50 min-h-screen p-4" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-5xl mx-auto space-y-8">
      
      <!-- HEADER -->
      <div class="mb-6">
        <h1 class="text-2xl font-bold text-slate-700">Tipos de Almoxarifado</h1>
        <p class="text-sm text-slate-500">Gerenciamento das categorias de estoque para itens de licitação</p>
      </div>

      <!-- FORMULÁRIO DE CADASTRO -->
      <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
              <v-icon color="orange" small>mdi-plus-box-outline</v-icon>
              <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">
                  {{ typeData.stock_item_id ? 'EDITAR TIPO' : 'NOVA TIPO' }}
              </h2>
          </div>
          
          <div class="p-8">
              <v-form @submit.prevent="createOrUpdate" class="grid grid-cols-1 md:grid-cols-12 gap-6 items-end">
                  <div class="md:col-span-12">
                      <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Descrição do Tipo de Almoxarifado</label>
                      <input 
                        v-model="typeData.stock_item_desc"
                        ref="secName"
                        type="text"
                        placeholder="Ex: Material de Expediente, Limpeza, etc."
                        class="w-full bg-slate-50 border border-slate-200 rounded-lg px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors uppercase"
                      >
                      <p v-if="typeData.stock_item_id" class="text-[10px] text-orange-500 font-bold mt-1 uppercase italic">
                        Editando registro #{{ typeData.stock_item_id }}
                      </p>
                  </div>
                  
                  <div class="md:col-span-12 flex justify-end gap-3 mt-4">
                      <button 
                        v-if="typeData.stock_item_id"
                        @click="newData"
                        type="button"
                        class="text-slate-500 hover:text-slate-700 font-bold text-[10px] uppercase px-4 py-2 transition-colors"
                      >
                        Cancelar
                      </button>
                      <button 
                        @click="createOrUpdate"
                        type="button"
                        class="bg-orange-500 hover:bg-orange-600 text-white font-bold text-[10px] px-10 py-2.5 rounded shadow hover:shadow-md transform hover:-translate-y-0.5 transition-all uppercase tracking-widest inline-flex items-center justify-center gap-2 w-auto max-w-max"
                      >
                        <v-icon small color="white" style="font-size: 12px;">{{ typeData.stock_item_id ? 'mdi-pencil' : 'mdi-check' }}</v-icon>
                        {{ typeData.stock_item_id ? 'EDITAR' : 'SALVAR' }}
                      </button>
                  </div>
              </v-form>
          </div>
      </section>

      <!-- LISTAGEM -->
      <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="px-4 py-4 flex items-center w-full" style="background-color: #333333;">
              <div class="flex items-center gap-2 flex-none">
                <v-icon color="orange" small>mdi-format-list-bulleted</v-icon>
                <h2 class="text-white font-bold uppercase tracking-wider text-[11px]">TIPOS CADASTRADOS</h2>
              </div>
              
              <div class="flex items-center gap-4 flex-1 justify-end">
                <div class="relative w-80">
                  <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <v-icon color="white" small class="opacity-50">mdi-magnify</v-icon>
                  </div>
                  <input 
                    v-model="search"
                    placeholder="PESQUISAR..."
                    class="bg-white/10 border border-white/20 rounded-lg py-2 pl-10 pr-4 text-[11px] text-white placeholder:text-white/40 focus:outline-none focus:bg-white/20 transition-all w-full uppercase tracking-widest"
                  >
                </div>
              </div>
          </div>

          <div class="overflow-x-auto">
             <v-data-table
              :headers="headers"
              :items="data"
              :search="search"
              :loading="loader"
              :items-per-page="10"
              class="custom-table"
            >
              <template v-slot:item.stock_item_desc="{ item }">
                <span class="text-sm font-bold text-slate-700 uppercase tracking-tight">{{ item.stock_item_desc }}</span>
              </template>

              <template v-slot:item.action="{ item }">
                 <div class="flex justify-end gap-2">
                    <button 
                      @click="loadData(item)"
                      class="p-2 rounded-lg text-slate-400 hover:bg-orange-50 hover:text-orange-500 transition-colors"
                    >
                      <v-icon small color="currentColor">mdi-pencil</v-icon>
                    </button>
                    <button 
                      @click="deleteItem(item.stock_item_id)"
                      class="p-2 rounded-lg text-slate-400 hover:bg-red-50 hover:text-red-500 transition-colors"
                    >
                      <v-icon small color="currentColor">mdi-delete</v-icon>
                    </button>
                 </div>
              </template>
             </v-data-table>
          </div>
      </section>

    </div>

    <!-- Snackbar -->
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      search: "",
      loader: true,
      showSearch: false,
      data: [],
      typeData: {
        stock_item_desc: "",
        stock_item_id: null
      },
      snack: {
        show: false,
        message: "",
        color: ""
      },
      headers: [
        { text: "Tipo de Almoxarifado", value: "stock_item_desc", class: "text-uppercase caption font-weight-bold" },
        { text: "Ações", align: "right", value: "action", sortable: false, class: "text-uppercase caption font-weight-bold" }
      ]
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loader = true;
      this.data = [];
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/biddings/items/stock_types`)
        .then(r => {
          this.data = r.data;
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch(e => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.color = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    newData() {
      this.typeData.stock_item_desc = "";
      this.typeData.stock_item_id = null;
      this.$refs.secName.focus();
    },
    loadData(data) {
      this.typeData.stock_item_desc = data.stock_item_desc;
      this.typeData.stock_item_id = data.stock_item_id;
    },
    createOrUpdate() {
      this.loader = true;
      const method = this.typeData.stock_item_id ? 'put' : 'post';
      const url = this.typeData.stock_item_id ? `/biddings/items/stock_types/${this.typeData.stock_item_id}` : `/biddings/items/stock_types`;
      
      this.$http[method](url, this.typeData)
        .then(r => {
          this.snack.show = true;
          this.snack.message = r.data.result || "Sucesso!";
          this.snack.color = "success";
          this.initialize();
          this.newData();
        })
        .catch(e => {
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.loader = false;
        });
    },
    deleteItem(id) {
      let c = confirm("Deseja excluir o registro?");
      if (c) {
        this.$http
          .delete(`/biddings/items/stock_types/${id}`)
          .then(r => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.initialize();
          })
          .catch(e => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
          });
      }
    }
  }
};
</script>

<style scoped>
/* Utility classes mimicking Tailwind */
.min-h-screen { min-height: 100vh; }
.bg-slate-50 { background-color: #f8fafc; }
.bg-white { background-color: #ffffff; }
.p-4 { padding: 1rem; }
.p-8 { padding: 2rem; }
.px-4 { padding-left: 1rem; padding-right: 1rem; }
.px-6 { padding-left: 1.5rem; padding-right: 1.5rem; }
.py-4 { padding-top: 1rem; padding-bottom: 1rem; }
.py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }
.pl-3 { padding-left: 0.75rem; }
.pl-10 { padding-left: 2.5rem; }
.pr-4 { padding-right: 1rem; }
.mb-2 { margin-bottom: 0.5rem; }
.mb-6 { margin-bottom: 1.5rem; }
.mt-1 { margin-top: 0.25rem; }
.mt-4 { margin-top: 1rem; }
.gap-2 { gap: 0.5rem; }
.gap-3 { gap: 0.75rem; }
.gap-4 { gap: 1rem; }
.gap-6 { gap: 1.5rem; }

.rounded-xl { border-radius: 0.75rem; }
.rounded-lg { border-radius: 0.5rem; }
.shadow-sm { box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05); }
.overflow-hidden { overflow: hidden; }
.border { border-style: solid; border-width: 1px; }
.border-slate-200 { border-color: #e2e8f0; }

.text-2xl { font-size: 1.5rem; line-height: 2rem; }
.text-slate-700 { color: #334155; }
.text-slate-500 { color: #64748b; }
.text-slate-400 { color: #94a3b8; }
.text-orange-500 { color: #f97316; }
.text-white { color: #ffffff; }
.font-bold { font-weight: 700; }
.uppercase { text-transform: uppercase; }
.tracking-wider { letter-spacing: 0.05em; }
.tracking-widest { letter-spacing: 0.1em; }
.italic { font-style: italic; }
.font-mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; }

/* Flexbox */
.flex { display: flex; }
.items-center { align-items: center; }
.justify-end { justify-content: flex-end; }
.grid { display: grid; }
@media (min-width: 768px) {
  .md\:grid-cols-12 { grid-template-columns: repeat(12, minmax(0, 1fr)); }
  .md\:col-span-12 { grid-column: span 12 / span 12; }
}

/* Custom Overrides */
.custom-table ::v-deep th {
  background-color: #f8fafc !important;
  color: #64748b !important;
  font-size: 0.65rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.05em !important;
  border-bottom: 1px solid #e2e8f0 !important;
  height: 48px !important;
}

.custom-table ::v-deep td {
  font-size: 0.825rem !important;
  color: #334155 !important;
  border-bottom: 1px solid #f1f5f9 !important;
  height: 60px !important;
}
</style>
